import { getDate, parseISO } from 'date-fns';
import { FIRST_OF_MONTH, MID_OF_MONTH } from '../constants/date';

export const timesheetStartsFirstDayOfMonth = (value: string) => {
  return getDate(parseISO(value)) === FIRST_OF_MONTH;
};

export const timesheetStartsMidOfMonth = (value: string) => {
  return getDate(parseISO(value)) === MID_OF_MONTH;
};

export function getDayName(dayNumberOrDate: number | Date, locale = 'en-US') {
  const date = typeof dayNumberOrDate === 'number' ? new Date(1970, 0, dayNumberOrDate + 4) : new Date(dayNumberOrDate);
  return new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);
}
